var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 7.33333H4.13325C3.38652 7.33333 3.01315 7.33333 2.72793 7.47866C2.47705 7.60649 2.27307 7.81046 2.14524 8.06135C1.99992 8.34656 1.99992 8.71993 1.99992 9.46667V14M13.9999 14V4.13333C13.9999 3.3866 13.9999 3.01323 13.8546 2.72801C13.7268 2.47713 13.5228 2.27316 13.2719 2.14532C12.9867 2 12.6133 2 11.8666 2H9.46659C8.71985 2 8.34648 2 8.06126 2.14532C7.81038 2.27316 7.60641 2.47713 7.47858 2.72801C7.33325 3.01323 7.33325 3.3866 7.33325 4.13333V14M14.6666 14H1.33325M9.66659 4.66667H11.6666M9.66659 7.33333H11.6666M9.66659 10H11.6666",
    stroke: "#424242",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding06);
export default __webpack_public_path__ + "static/media/building-06.b3524ff18e2b99e2b14ee79e69440580.svg";
export { ForwardRef as ReactComponent };